import ApiHandler from './ApiHandler';

export default {
    getNationalities: ({ gender, type }) => {
        const queryParams = new URLSearchParams();
        if (gender) {
            queryParams.append('gender', gender);
        }
        if (type) {
            queryParams.append('type', type);
        }
        return ApiHandler.get(
            `/club${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
        );
    },
    allClubs: () => ApiHandler.get(`/club`)
};
